



















































































import { Prop, Component, Vue } from 'vue-property-decorator'
import * as helper from '@/assets/_js/helpers'
import { vxm } from '@/store/'
import { Package } from 'dapp-client'
import ActionButtons from '@/components/common/ActionButtons.vue'
const numeral = require('numeral')

@Component({
  components: {
    ActionButtons
  }
})
export default class PackagesTable extends Vue {
  // props
  @Prop() private pkg!: Package
  // data
  private numeral = numeral
  private loading = true
  detailedPkg: any = {
    pkgJson: {
      error: true,
      errorMsg: '',
      data: {}
    },
    dspJson: {
      error: true,
      errorMsg: '',
      data: {}
    }
  }

  // computed
  get getNameLogo() {
    return helper.nameLogo(
      this.pkg.provider,
      this.detailedPkg.pkgJson,
      this.detailedPkg.dspJson
    )
  }

  get prettyServiceString() {
    return helper.prettyServiceString(this.pkg.service)
  }

  get isAuthenticated() {
    return (
      vxm.transit.walletState.authenticated &&
      !vxm.transit.walletState.authenticationError
    )
  }

  get isDeprecated() {
    return !(
      this.pkg.api_endpoint !== '' &&
      this.pkg.api_endpoint !== null &&
      this.pkg.api_endpoint !== 'null' &&
      this.pkg.api_endpoint !== undefined
    )
  }

  // methods
  selectPackage(pkg2select: any) {
    vxm.packages.selectPackage(pkg2select)
  }
  closePrv(prv2close: any) {
    vxm.packages.closePrv(prv2close)
  }

  getRefund(prv: any) {
    vxm.packages.getRefund(prv)
  }

  openStakingModal(action: string) {
    vxm.modals.setStakingModal({
      pkg: this.pkg,
      detailedPkg: this.detailedPkg,
      action: action
    })
    this.$bvModal.show('modal-staking')
  }

  isPkgSelected(pkg: any) {
    let result = false
    for (const el of vxm.user.selectedPackages) {
      if (
        el.provider === pkg.provider &&
        el.pending_package === pkg.package_id &&
        el.service === pkg.service
      ) {
        result = true
      }
    }
    return result
  }

  // Lifecycle hooks
  created() {}
  async mounted() {
    let pkgJson = await vxm.jsondb.getPkgJson(this.pkg)
    let dspJson = await vxm.jsondb.getDspJson(this.pkg)
    this.detailedPkg.pkgJson = pkgJson
    this.detailedPkg.dspJson = dspJson
    this.loading = false
  }
  updated() {}
  destroyed() {}
}
